import React from 'react';
import PropTypes from 'prop-types';
import MarkdownField from 'components/Shared/MarkdownField/MarkdownField';

/** Project description with Write / Preview tabs and the formatting guide. */
const ProjectDescriptionField = ({ value, onChange, disabled, error }) => (
  <MarkdownField
    id="project-description"
    label="Description"
    value={value}
    onChange={onChange}
    disabled={disabled}
    error={error}
    placeholder="What was the brief, what did you make, what was the result?"
    previewCaption="This is how the description will look on the project page."
  />
);

ProjectDescriptionField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

ProjectDescriptionField.defaultProps = {
  value: '',
  disabled: false,
  error: null,
};

export default ProjectDescriptionField;
